/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PerformerOnboardingStatus {
    Cancelled = 'cancelled',
    NotStarted = 'not_started',
    Invited = 'invited',
    InvitationAccepted = 'invitation_accepted',
    Completed = 'completed',
}
